<template>
  <div id="formallyAproved">
		<el-card :class="detailShow? 'hiddencard' : ''">
			<el-form :model="searchForm" ref="searchForm" label-width="170px">
				<el-row>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Name:" prop="projectName">
							<el-input clearable v-model="searchForm.projectName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Service Delivery Notice Number:" prop="serviceDeliveryNotificationNumber" class="longlabel">
							<el-input clearable v-model="searchForm.serviceDeliveryNotificationNumber" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Major Project Initiation Status:" prop="proposalStatus" class="longlabel">
							<el-select clearable v-model="searchForm.proposalStatus" placeholder="Please select">
								<el-option
									v-for="item in proposalStatus"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Customer Name:" prop="customerName">
							<el-input clearable v-model="searchForm.customerName" placeholder="Please input" />
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Sub Industry:" prop="customerIndustry">
							<el-input clearable v-model="searchForm.customerIndustry" placeholder="Please input" />
							<!-- <el-select clearable v-model="searchForm.customerIndustry" placeholder="Please select">
								<el-option
									v-for="item in customerIndustry"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select> -->
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12">
						<el-form-item label="Project Manager:" prop="projectManager">
							<el-select
								v-model="searchForm.projectManager"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('projectManagerList', value)"
							>
								<el-option v-for="(item, index) in projectManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMore">
						<el-form-item label="Technical Manager:" prop="developmentLeader">
							<el-select
								v-model="searchForm.developmentLeader"
								clearable
								filterable
								remote
								placeholder="Please input"
								:remote-method="value => remoteMethod('developmentLeaderList', value)"
							>
								<el-option v-for="(item, index) in developmentLeaderList.slice(0, 10)" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMore">
						<el-form-item label="Engineering Type:" prop="projectTypeList">
							<el-select multiple clearable v-model="searchForm.projectTypeList" placeholder="Please select">
								<el-option
									v-for="item in engineeringType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMore">
						<el-form-item label="Major Project Type:" prop="majorProjectType">
							<el-select clearable v-model="searchForm.majorProjectType" placeholder="Please select">
								<el-option
									v-for="item in majorProjectType"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="6" :lg="8" :md="12" v-if="showMore">
						<el-form-item label="Major Project Category:" prop="majorProjectCategoryList">
							<el-select multiple clearable v-model="searchForm.majorProjectCategoryList" placeholder="Please select">
								<el-option
									v-for="item in majorProjectCategory"
									:key="item.labelKey"
									:label="item.labelValue"
									:value="item.labelKey"
								>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :xl="12" :lg="showMore ? 16 : 24" :md="24" style="padding: 10px 0 0 20px; text-align: right;">
						<el-button type="primary" size="small" @click="filterMoreSearch">Advanced Filter</el-button>
						<el-button type="primary" size="small" @click="handleSearch()">Search</el-button>
						<el-button size="small" @click="handleReset()">Reset</el-button>
					</el-col>
				</el-row>
			</el-form>
			<el-table :data="tableData" border v-loading="tableLoading" style="width: 100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
        <el-table-column prop="id" label="id" v-if="false" ></el-table-column>
        <el-table-column prop="projectName" label="Project Name" align="center" min-width="160" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<a style="color:blue;" @click="openDetail(scope.row)">{{ scope.row.projectName }}</a>
					</template>
				</el-table-column>
        <el-table-column prop="departmentDesc" label="Department" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="serviceDeliveryNotificationNumber" label="Service Delivery Notice Number" min-width="130" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="proposalStatusDesc" label="Major Project Initiation Status" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="officialProjectLaunchTime" label="Major Project Initiation Date" min-width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="projectManagerDesc" label="Project Manager" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="developmentLeaderDesc" label="Technical Manager" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="majorProjectCategoryDesc" label="Major Project Category" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="customerIndustry" label="Sub Industry" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="operation" label="Operation" align="center" min-width="100">
					<template slot-scope="scope">
          	<el-button size="small" type="primary" @click="openEdit(scope.row)" v-if="scope.row.proposalStatus === 0">Edit</el-button>
          	<el-button size="small" type="primary" @click="openEdit(scope.row)" v-else>Detail</el-button>
					</template>
				</el-table-column>
      </el-table>
			<div class="pageDiv" v-if="totalCount && totalCount > 0">
				<el-pagination
					small
					layout="total, prev, pager, next, sizes, jumper"
					:page-sizes="[10, 20, 50, 100]"
					:current-page="currentPage"
					:page-size="pageSize"
					:total="totalCount"
					@size-change="changePageSize"
					@current-change="changePage"
				>
				</el-pagination>
			</div>
		</el-card>
		<el-dialog
			:title="editDisabled ? 'Detail' : 'Edit'"
			width="600px"
			:visible.sync="editVisible"
			:destroy-on-close="true"
			:close-on-click-modal="false"
		>
			<el-form :model="editForm" ref="editForm" label-width="255px">
				<el-form-item label="Project Name" prop="projectName" :rules="[{ required: true, message: 'Please input' }]">
					<el-input clearable v-model="editForm.projectName" :disabled="editDisabled" placeholder="Please input reason" />
				</el-form-item>
				<el-form-item label="Service Delivery Notice Number:" prop="serviceDeliveryNotificationNumber" :rules="[{ required: true, message: 'Please input' }]">
					<el-input clearable v-model="editForm.serviceDeliveryNotificationNumber" :disabled="editDisabled" placeholder="Please input" />
				</el-form-item>
				<el-form-item label="Major Project Initiation Date:" prop="officialProjectLaunchTime" :rules="[{ required: true, message: 'Please input' }]">
					<el-date-picker
						v-model="editForm.officialProjectLaunchTime"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss" 
						placeholder="Please select"
						:disabled="editDisabled"
					>
					</el-date-picker>
				</el-form-item>
				<el-form-item label="Official Project Document:" prop="file" :rules="[{ required: true, message: 'Please upload' }]">
					<el-upload
						class="upload-demo"
						action="#"
						:http-request="changeFile"
						:file-list="fileList"
						:show-file-list="false"
						:before-upload="beforeUpload"
						:limit="1"
						:on-exceed="handleExceed"
						v-model="editForm.file"
					>
						<el-button size="small" type="primary" :disabled="editDisabled">Upload</el-button>
					</el-upload>
					<div class="el-upload-newlist">
						<div v-for="(item, index) in fileList" :key="index" class="el-upload-file-box">
							<a class="file-name" @click="handlePreview(item)"><i class="el-icon-document" />{{ item.name }}</a>
							<label>
								<span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
								<i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
								<i class="el-icon-close icon-close" style="display: none" @click="handleRemove"></i>
							</label>
							<el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
						</div>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeEdit()">Cancel</el-button>
				<el-button type="primary" :loading="editLoading" size="small" @click="eidtConfirm()" v-if="!editDisabled">Confirm</el-button>
			</span>
		</el-dialog>
		<detail v-if="detailShow" :id="detailId" page="formallyAproved" @closeDetail="closeDetail" />
  </div>
</template>
<script>
	import detail from '../projectApplication/index.vue'
	import axios from 'axios'
  export default {
    name: 'formallyAproved',
		components: {
			detail
		},
    created () {
			this.getSelectInfo();
			this.handleSearch();
    },
    data () {
      return {
				majorProjectType: [],
				engineeringType: [],
				majorProjectCategory: [],
				majorProjectLevel: [],
				customerIndustry: [],
				projectManagerList: [],
				proposalStatus: [{
					labelKey: 0,
					labelValue: 'Not Formal Major Project Initiated',
				},{
					labelKey: 1,
					labelValue: 'Formal Major Project Initiated',
				}],
				developmentLeaderList: [],
        searchForm: {},
				showMore: false,
				tableData: [],
				tableLoading: false,
				currentPage: 1,
				pageSize: 10,
				totalCount: 1,
				exportLoading: false,
				editVisible: false,
				editForm: {},
				fileList: [],
				editLoading: false,
				editDisabled: true,
				detailShow: false,
				detailId: '',
				cancelUpload: null
      }
    },
    methods: {
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectType',
					'majorProjectCategory',
					'majorProjectLevel',
					// 'customerIndustry',
					'engineeringType',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								_this[key] = res.data[key];
							});
						}
					}
				)
			},
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			handleSearch() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
					eosToken : sessionStorage.getItem('eostoken'),
					...this.searchForm,
				}
				this.tableLoading = true;
				let url =`${this.$store.state.islhurl}officialProjectLaunch/getListByPage/${this.pageSize}/${this.currentPage}`
				this._post(url,params).then(
					res => {
						this.tableLoading = false;
						if(res.code === 200) {
						this.tableData = res.data;
						this.totalCount = res.totalNums;
						} else {
							this.tableData = [];
							this.$message.error(res.message || 'Failed!' );
						}
					}
				)
			},
			changePageSize(size) {
				this.pageSize = size;
				this.handleSearch();
			},
			changePage(current) {
				this.currentPage = current;
				this.handleSearch();
			},
			handleReset() {
				this.searchForm = {};
			},
			handleExport() {
				this.exportLoading = true;
				this.exportLoading = false;
			},
			// openDetail(record) {
			// 	let params = {
			// 		id: record.id,
			// 		page: 'formallyApprovedProject'
			// 	}
			// 	this.$router.push({ name:'projectApplication', params });
			// },
			openDetail(record) {
				this.detailShow = true;
				this.detailId = record.id;
			},
			closeDetail() {
				this.detailShow = false;
				this.detailId = '';
			},
			filterMoreSearch() {
				this.showMore = !this.showMore;
			},
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
          return false;
        }
      },
			changeFile(row) {
				const file = row.file;
				let fd = new FormData();
				fd.append('file', file);
				let params = {
					islhToken: sessionStorage.getItem("islhtoken"),
				}
				fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
				let url = `${this.$store.state.islhurl}s3/upload`
				// 创建 CancelToken
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				this.cancelUpload = source.cancel; // 存储取消函数
				this._post(url, fd, {
					cancelToken: source.token, // 绑定 CancelToken
					onUploadProgress: (percent) => {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							uploadPercentage: percent === 100 ? 99 : percent,
						}];
						// 通知Upload组件内部进度更新
					},
					noProgress: true // 禁用全局NProgress
				}).then(res => {
					if(res.code == 200) {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							id: res.data.id,
							fileId: res.data.id,
							uploadPercentage: 100,
						}];
						this.editForm = {
							...this.editForm,
							file: file,
						};
					} else {
						this.fileList = [];
						this.$message.error(res.message || 'Failed!' );
					}
				}).catch(error => {
					console.log(error)
					this.fileList = [];
				})
      },
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
			handlePreview(file) {
				if(file.url) {
					window.open(file.url)
				}
			},
			beforeRemove() {
				if(this.editDisabled) {
					return false;
				}
			},
			handleRemove() {
				if(this.editDisabled) {
					return false;
				}
				if (typeof this.cancelUpload === 'function') {
					this.cancelUpload('User canceled upload');
					this.cancelUpload = null;
				}
				this.fileList = [];
				this.editForm = {
					...this.editForm,
					file: []
				};
			},
			openEdit(record) {
				this.editVisible = true
				this.editDisabled = record.proposalStatus !== 0
				this.editForm = {
					...record,
					file: record.fileName || []
				};
				this.$nextTick(() => {
					this.$refs.editForm.clearValidate();
				});
				if(record.fileName) {
					this.fileList = [{
						fileName: record.fileName,
						name: record.fileName,
						fileAliasName: record.fileAliasName,
						url: `${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(record.fileAliasName)}&fileName=${encodeURIComponent(record.fileName)}`
					}]
				}
			},
			closeEdit() {
				this.editVisible = false
				this.editForm = {};
				this.fileList = [];
			},
			eidtConfirm() {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						let majorProject = {
							id: this.editForm.id,
							serviceDeliveryNotificationNumber: this.editForm.serviceDeliveryNotificationNumber,
							officialProjectLaunchTime: this.editForm.officialProjectLaunchTime,
							islhToken : sessionStorage.getItem('islhtoken'),
          		eosToken : sessionStorage.getItem('eostoken'),
						}
						let fd = new FormData();
						// Object.keys(this.editForm).forEach(key => {
						// 	fd.append(key, this.editForm[key]);
						// })
						// fd.append('file', this.editForm.file);
						if(this.fileList && this.fileList.length > 0) {
							if(this.fileList[0].fileAliasName) {
								majorProject.fileAliasName = this.fileList[0].fileAliasName;
								majorProject.fileName = this.fileList[0].fileName;
							} else {
								// fd.append('file', this.editForm.file);
							}
							majorProject.fileId = this.fileList[0].fileId;
						}
						fd.append('majorProject', new Blob([JSON.stringify(majorProject)], {type: 'application/json'}));
						let url =`${this.$store.state.islhurl}officialProjectLaunch/edit`;
						this.editLoading = true;
						this._post(url, fd).then(
							res => {
								if(res.code === 200) {
									this.$Message.success('Successful!');
									this.closeEdit();
									this.handleSearch();
								} else {
									this.$message.error(res.message || 'Failed!');
								}
								this.editLoading = false;
							}
						)
						this.editLoading = false;
					} else {
						return false;
					}
				});
			}
		},
  }
</script>
<style lang="less" scoped>
#formallyAproved {
	.el-message {
		z-index: 99999;
	}
	.hiddencard {
		height: 0;
		overflow: hidden;
	}
	.el-form {
		padding: 20px 0 20px 0;
		.el-form-item {
			margin-bottom: 10px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 0px;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 100%!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
		}
	}
	.el-table {
		/deep/th.el-table__cell>.cell {
			word-break: break-word;
		}
	}
	.longlabel {
		/deep/.el-form-item__label {
			padding: 0 12px;
			line-height: 20px;
		}
	}
	/deep/.el-dialog__body {
		border-top: 1px solid #e8eaec;
		border-bottom: 1px solid #e8eaec;
		.el-form {
			padding: 0;
			.el-form-item {
				margin-bottom: 20px;
			}
		}
	}
}
.el-upload-newlist {
	width: 300px;
	.el-upload-file-box {
		margin-top: 10px;
		border-radius: 4px;
		position: relative;
		line-height: 26px;
		.file-name {
			line-height: 26px;
			color: #606266;
			display: block;
			margin-right: 40px;
			overflow: hidden;
			padding-left: 4px;
			text-overflow: ellipsis;
			-webkit-transition: color .3s;
			transition: color .3s;
			white-space: nowrap;
			i {
				margin-right: 7px;
    		color: #909399;
			}
		}
		.file-name:hover {
			color: #409eff;
		}
		label {
			position: absolute;
			right: 5px;
			top: 0;
			line-height: inherit;
			i {
				line-height: 26px;
			}
			.icon-close {
				cursor: pointer;
			}
			.percentage {
				color: #666;
				font-size: 12px;
			}
		}
	}
	.el-upload-file-box:hover {
		background-color: #f5f7fa;
		.icon-check, .percentage {
			display: none;
		}
		.icon-close {
			display: block !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/formallyApproved/index.vue